var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201.473,
    height: 36.802,
    viewBox: "0 0 201.473 36.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-224 -47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.269 44.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.628,23.516H271.022a2.756,2.756,0,0,0,1.789,2.579,12.968,12.968,0,0,0,4.081.774,37.9,37.9,0,0,0,4.993-.615l.729,3.929a21.428,21.428,0,0,1-8.484,1,13.09,13.09,0,0,1-2.406-.436,8.531,8.531,0,0,1-6.524-9.368c.314-4.692,3.266-8.045,7.681-8.774a11.171,11.171,0,0,1,5.709.479c3.585,1.3,5.533,4.794,5.181,9.2C283.742,22.65,283.688,23.006,283.628,23.516Zm-5.364-3.5a3.272,3.272,0,0,0-3.528-3.4,3.333,3.333,0,0,0-3.6,3.4Z",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.108,25.816l1.311,4.273c-.865.364-1.681.763-2.533,1.057a14.836,14.836,0,0,1-7.655.5,8.958,8.958,0,0,1-7.007-5.54,17.684,17.684,0,0,1-.192-13.767c2.093-5.249,7.263-7.785,12.913-6.479a23.363,23.363,0,0,1,3.57,1.311.856.856,0,0,1,.408.716c-.384,1.376-.842,2.732-1.216,3.908a31.358,31.358,0,0,0-4.717-1.12c-3.605-.3-5.74,1.361-6.616,4.876a13.291,13.291,0,0,0,.111,6.8,5.567,5.567,0,0,0,6.264,4.465A48.335,48.335,0,0,0,215.108,25.816Z",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.733,21.5a69.027,69.027,0,0,1,7.471,9.671c-2.145,0-4.1.025-6.043-.029-.262-.007-.573-.366-.762-.633-1.036-1.471-2.032-2.969-3.062-4.444-.276-.394-.625-.737-1.085-1.272-1.335,1.927-2.632,3.727-3.84,5.584a1.5,1.5,0,0,1-1.485.815c-1.634-.055-3.27-.018-5.143-.018a70.012,70.012,0,0,1,7.322-9.6l-7.158-9.032c2.207,0,4.192-.021,6.176.026.247.005.536.327.718.569,1.238,1.647,2.452,3.313,3.741,5.064,1.232-1.668,2.448-3.246,3.581-4.882a1.666,1.666,0,0,1,1.624-.8c1.624.055,3.251.017,5.148.017Z",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.411,37.1l.741-4.044c.563.127,1.055.275,1.558.345,2.18.3,2.965-.659,3.631-2.6.094-.271-.129-.678-.264-1a112.126,112.126,0,0,1-5.3-15.79c-.071-.279-.109-.567-.174-.914h4.553q1.616,5.865,3.226,11.708l.253.028c.124-.366.273-.726.367-1.1.8-3.136,1.625-6.265,2.343-9.419.217-.954.508-1.41,1.573-1.293a29.757,29.757,0,0,0,3.2.025,4.388,4.388,0,0,1-.055.717,145.272,145.272,0,0,1-6.075,18.842c-.211.513-.46,1.011-.7,1.515C237.486,37.968,234.117,38.587,230.411,37.1Z",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.986,3.3V4.443q0,9.378,0,18.756c0,.164,0,.328,0,.491.041,2.185.517,2.75,2.786,3.179-.1.687-.2,1.383-.318,2.076s-.245,1.405-.382,2.184a8.329,8.329,0,0,1-5.429-1.355,4.574,4.574,0,0,1-1.744-3.585c-.081-1.141-.089-2.289-.091-3.434q-.012-8.739,0-17.48v-1.1Z",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.622,26.935c-.232,1.41-.455,2.762-.692,4.2a8.586,8.586,0,0,1-5.354-1.286,4.129,4.129,0,0,1-1.7-2.779,15.219,15.219,0,0,1-.221-2.539c-.018-6.455-.01-12.911-.01-19.366V4.178l5.147-.866V4.565q0,9.043,0,18.088c0,.229,0,.459,0,.688C252.82,25.828,253.156,26.271,255.622,26.935Z",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.87,31.86h-4.734a6.906,6.906,0,0,1-.071-.693c0-5.271.018-10.543-.011-15.814a1.088,1.088,0,0,1,.9-1.238c3.738-1.238,7.135-1.38,10.017-.3-.253,1.369-.509,2.761-.745,4.041l-5.356-.346Z",
    fill: "#0533b3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -39.916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.794,12.658H139.329L147.471,1.97h51.465Z",
    transform: "translate(105.064 84.947)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.669,25.408H119.2l8.142-10.688h51.465Z",
    transform: "translate(104.796 85.254)",
    fill: "#0533b3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.544,38.158H126.079l8.142-10.688h51.465Z",
    transform: "translate(105.004 85.56)",
    fill: "#0533b3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.75d7168df6836af3cc59d6a3b1aebcb9.svg";
export { ForwardRef as ReactComponent };